module.exports = __webpack_public_path__ + "img/wellgistics.f561bdf8.png";